import { getUserData } from 'queries/ossix/user/userData';
import { useEffect, useState } from 'react';
import socketIOClient from './socketIO';
import { useStatus } from 'hooks/useStatusProvider';
import { useUpdateConfirmModal } from 'hooks/useConfirmModal';
import { useExecOp } from 'Contexts/ExecOpContext';

export const WALLET_UPDATED = 'WalletUpdated';

const MyComponent = () => {
  const { setExecOpInProgress } = useExecOp();
  const { setUpdateStatus, setProps } = useUpdateConfirmModal();
  const { userData } = getUserData();
  const { status, setStatus } = useStatus();
  const [message, setMessage] = useState<string>('');

  const data = userData?.[0];

  const onHandleUpdateStatus = () => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      isCanceled: false,
      isPending: true,
      isSuccess: true,
    }));
  };

  useEffect(() => {
    if (data && data.PID) {
      socketIOClient.off(WALLET_UPDATED);
      socketIOClient.on(WALLET_UPDATED, (notification) => {
        const { message } = notification || {};
        setMessage(message);
        onHandleUpdateStatus();
        setExecOpInProgress(false);
        localStorage.removeItem('opExInProgress');
      });
    }

    return () => {
      socketIOClient.off(WALLET_UPDATED);
    };
  }, [data && data.PID]);

  useEffect(() => {
    if (status.isSuccess) {
      setUpdateStatus({
        isCanceled: false,
        isPending: false,
        isSuccess: true,
        closePending: true,
      });
      setProps({ message: message });
    }
  }, [status]);

  return null;
};

export default MyComponent;
